import "./News.sass";

const NewsCard = ({ news }) => {
  // Extract text from HTML content for preview
  const getPreviewText = (htmlContent) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const text = tempDiv.textContent || tempDiv.innerText || '';
    return text.length > 150 ? text.substring(0, 150) + '...' : text;
  };

  return (
    <div className="news-card">
      {news.titleImage && (
        <div className="news-card__image-container">
          <img src={news.titleImage} alt={news.title} className="news-card__image" />
        </div>
      )}      <div className="news-card__content">
        <h2 className="news-card__title">{news.title}</h2>
        <p className="news-card__date">{new Date(news.date).toLocaleDateString('pl-PL')}</p>
        <p className="news-card__preview">{getPreviewText(news.content)}</p>
        <span className="news-card__read-more">Czytaj więcej</span>
      </div>
    </div>
  );
};

export default NewsCard;